import React from 'react';

//helpers and hooks
import { checkValue } from 'src/components/common/helper';

const ignoreTheseModules = ['entryFormModule', 'quoteModule', 'v2QuoteModule', 'v2HotelDealsModule'];

const determineModuleVisibility = (userStatus, moduleName, moduleProps, component) => {
  if (ignoreTheseModules.indexOf(moduleName) > -1) {
    return component;
  } else {
    const isUSerSignedIn =
      (checkValue(userStatus?.authState) && userStatus?.authState === 'AUTHENTICATED') ||
      (checkValue(userStatus?.expUserId) && userStatus?.expUserId.toString() !== '-1')
    let requireSignIn = false;
    let hideAfterSignIn = false;
    if (moduleName === 'globalHero' || moduleName === 'v2GlobalHero') {
      requireSignIn = moduleProps?.data?.heroData?.requireSignIn === 'True';
      hideAfterSignIn = moduleProps?.data?.heroData?.hideAfterSignIn === 'True';
    } else {
      requireSignIn = moduleProps?.data?.requireSignIn === 'True';
      hideAfterSignIn = moduleProps?.data?.hideAfterSignIn === 'True';
    }

    switch (true) {
      case requireSignIn && !hideAfterSignIn && isUSerSignedIn:
      case !requireSignIn && hideAfterSignIn && !isUSerSignedIn:
      case !requireSignIn && !hideAfterSignIn && isUSerSignedIn:
      case !requireSignIn && !hideAfterSignIn && !isUSerSignedIn:
        return component;
      case requireSignIn && hideAfterSignIn && isUSerSignedIn:
      case requireSignIn && hideAfterSignIn && !isUSerSignedIn:
      case requireSignIn && !hideAfterSignIn && !isUSerSignedIn:
      case !requireSignIn && hideAfterSignIn && isUSerSignedIn:
        return <></>;
      default:
        return <></>;
    }
  }
};

export default determineModuleVisibility;

{
  /* 
    Logic for module visibility

    case  | requireSignIn | hideAfterSignIn | isUSerSignedIn | result
    1     | true          | true            | true           | hidden
    2     | true          | true            | false          | hidden
    3     | true          | false           | true           | visible
    4     | true          | false           | false          | hidden
    5     | false         | true            | true           | hidden
    6     | false         | true            | false          | visble
    7     | false         | false           | true           | visble
    8     | false         | false           | false          | visble
*/
}
